module.exports = __webpack_public_path__ + "img/nav.5be0adb6.jpg";